import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import CaisseAlertsPage from './CaisseAlertsPage';
import CaisseJournalPage from './CaisseJournalPage';
import CaissePrincipalePage from './CaissePrincipalePage';
import CaisseClosurePage from './CaisseClosurePage';
import GestionBonsPage from './GestionBonsPage';
import CaisseReconciliationPage from './CaisseReconciliationPage';
import FundsTransferPage from './FundsTransferPage';
import MovementsHistoryPage from './MovementsHistoryPage';
import TreasuryConfigPage from './TreasuryConfigPage';
import OperationTypesPage from './OperationTypesPage';
import OperationsHierarchyPage from './OperationsHierarchyPage';
import TreasuryAnalysesRapportsPage from './TreasuryAnalysesRapportsPage';
import CashDashboardPage from './CashDashboardPage';

const TreasuryMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.caisse.pages.treasuryMainPage.${key}`, opts);
  const location = useLocation();

  return (
    <div className="min-h-screen" aria-label={p('title')}>
      <span className="sr-only">{p('subtitle')}</span>
      <Routes location={location}>
        <Route path="/dashboard" element={<CashDashboardPage />} />
        <Route path="/alertes" element={<CaisseAlertsPage />} />
        <Route path="/journal" element={<CaisseJournalPage />} />
        <Route path="/main" element={<CaissePrincipalePage />} />
        <Route path="/closure" element={<CaisseClosurePage />} />
        <Route path="/vouchers" element={<GestionBonsPage />} />
        <Route path="/reconciliation" element={<CaisseReconciliationPage />} />
        <Route path="/transfers" element={<FundsTransferPage />} />
        <Route path="/history" element={<MovementsHistoryPage />} />
        <Route path="/operations" element={<OperationTypesPage />} />
        <Route path="/hierarchy" element={<OperationsHierarchyPage />} />
        <Route path="/config" element={<TreasuryConfigPage />} />
        <Route path="/analyses-rapports" element={<TreasuryAnalysesRapportsPage />} />
        <Route path="/" element={<Navigate to="/treasury/dashboard" replace />} />
      </Routes>
    </div>
  );
};

export default TreasuryMainPage;

